import { useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { GlobalStateContext } from 'context/GlobalContextProvider'
import { apolloClient } from 'lib/withApollo'
import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import ABOUT_QUERY from 'graphql/about.query'

import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import Blocks from 'components/Blocks'

import s from './about.module.css'

//TODO: Add proptypes
function About({ acfBlocks, site, globalSettings }) {
  const state = useContext(GlobalStateContext)
  return (
    <Layout globalSettings={globalSettings}>
      <WordpressSEO url={`/${site}/about`} title="About" />
      <div className={s.container}>
        {acfBlocks && <Blocks postType="Page">{acfBlocks}</Blocks>}
      </div>
    </Layout>
  )
}

About.propTypes = {
  globalSettings: PropTypes.object,
}
About.defaultProps = {
  globalSettings: {},
}

export default About

export async function getStaticProps({ params }) {
  const { site } = params

  const { data, error } = await apolloClient().query({
    query: ABOUT_QUERY,
    context: { site },
    variables: {
      slug: 'about',
    },
  })

  if (error) console.log(`Error loading About props - ${error}`)

  return {
    props: {
      ...params,
      ...data.pageBy,
    },
    revalidate: 60 * 2,
  }
}

export async function getStaticPaths() {
  const sites = await getSitesForStaticPaths()

  const paths = sites.map((site) => ({
    params: {
      site: site,
    },
  }))

  return {
    paths,
    fallback: false,
  }
}
